var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemiColoumleft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 26.3C0.766667 25.4333 0.7 24.5667 0.7 23.7C0.7 22.8333 0.7 22.1333 0.7 21.6C0.833334 17.6 1.6 13.7667 3 10.1C4.46667 6.43333 6.23333 3.13333 8.3 0.199999L17.2 2.6C15.8667 5.53333 14.8333 8.63333 14.1 11.9C13.3667 15.1667 13 18.2667 13 21.2C13 21.7333 13 22.5 13 23.5C13 24.5 13.0667 25.4333 13.2 26.3H0.9ZM21 26.3C20.8667 25.4333 20.8 24.5667 20.8 23.7C20.8 22.8333 20.8 22.1333 20.8 21.6C20.9333 17.6 21.7 13.7667 23.1 10.1C24.5667 6.43333 26.3333 3.13333 28.4 0.199999L37.3 2.6C35.9667 5.53333 34.9333 8.63333 34.2 11.9C33.4667 15.1667 33.1 18.2667 33.1 21.2C33.1 21.7333 33.1 22.5 33.1 23.5C33.1 24.5 33.1667 25.4333 33.3 26.3H21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiColoumleft);
export default __webpack_public_path__ + "static/media/semi-coloum left.48ed3b1b888964bb1a98a760a1fee2ea.svg";
export { ForwardRef as ReactComponent };